import { ROLE_PLANNER } from 'lib/helpers/roles'
import type { UserProfileContextValue } from 'lib/providers/common'
import type { IUserProfile } from 'models/userProfiles'
import React, { useContext } from 'react'

export const isUserProfileInitialized = (
	userProfile: IUserProfile | undefined
): boolean => {
	if (!userProfile?.role) {
		return false
	}

	if (userProfile.role !== ROLE_PLANNER) {
		return true
	}

	return Boolean(userProfile.accountType)
}

export const UserProfileContext =
	React.createContext<UserProfileContextValue | null>(null)

export const useUserProfileContext = (): UserProfileContextValue => {
	const context = useContext(UserProfileContext)
	if (!context) {
		throw new Error(
			'useUserProfileContext must be used within a UserProfileProvider'
		)
	}
	return context
}
